import { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react';
import FormMaster from '../FormMaster'
import { CommonService } from "../../../services";
import { isEmpty } from 'lodash';

let firstRender = false
const JobType = inject("authenStore")(observer((props) => {
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [optionStatus, setOptionStatus] = useState([])

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "common_status")
        .then((res: any) => {
          let common_status = res.result.common_status.map((item) => ({ label: item.status_name, value: item.status_code }))
          setOptionStatus(common_status)
        })
        .catch((err) => {
          console.log(`Load master data : ${err}`)
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])


  return <FormMaster
    title="ข้อมูลประเภทงาน"
    tableConfig={{
      key: "id",
      apiPath: "job_type/list",
      allowDelete: {
        visible: true,
        key: "job_type_id",
        apiPath: "job_type/delete",
        paramType: 'param'
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: "ลำดับ",
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'job_type_code',
          caption: "รหัสประเภทงาน",
          allowFiltering: true
        },
        {
          dataField: 'job_type_name',
          caption: "ชื่อประเภทงาน",
          allowFiltering: true
        },
        {
          dataField: 'temp_start',
          caption: "อุณหภูมิควบคุมเริ่มต้น",
          alignment: "start"

        },
        {
          dataField: 'temp_end',
          caption: "อุณหภูมิควบคุมสิ้นสุด",
          alignment: "start"
        },
        {
          dataField: 'status_name',
          caption: "สถานะ",
          allowFiltering: true
        },
        {
          dataField: 'updated_by',
          caption: "แก้ไขโดย"
        }
      ],
      exportExcel: {
        fileName: 'ข้อมูลประเภทงาน',
        columnConfig: [
          { label: 'ลำดับ', value: 'no' },
          { label: 'รหัสประเภทงาน', value: 'job_type_code' },
          { label: 'ชื่อประเภทงาน', value: 'job_type_name' },
          { label: 'อุณหภูมิควบคุมเริ่มต้น', value: 'temp_start' },
          { label: 'อุณหภูมิควบคุมสิ้นสุด', value: 'temp_end' },
          { label: 'สถานะ', value: 'XXXstatus_nameX' },
          { label: 'แก้ไขโดย', value: 'updated_by' }
        ]
      }
    }}
    formData={{
      job_type_code: "",
      job_type_name: "",
      temp_start: "",
      temp_end: "",
      status: "Y"
    }}
    modalConfig={{
      visible: true,
      title: "ประเภทงาน",
      required: ["job_type_name"],
      fieldTypeNumber: [],
      paramName: "job_type_id",
      apiPath: {
        "get": '',
        "post": 'job_type/add',
        "put": 'job_type/update'
      },
      elements: [
        {
          fieldName: "job_type_code",
          label: "รหัสประเภทงาน",
          placeholder: "รหัสประเภทงาน",
          inputType: "text",
          isOneRow: true
        },
        {
          fieldName: "job_type_name",
          label: "ชื่อประเภทงาน",
          placeholder: "ชื่อประเภทงาน",
          required: true,
          inputType: "text",
          isOneRow: true
        },
        {
          fieldName: "temp_start",
          label: "อุณหภูมิควบคุมเริ่มต้น",
          placeholder: "อุณหภูมิควบคุมเริ่มต้น",
          inputType: "number",
          isOneRow: true
        },
        {
          fieldName: "temp_end",
          label: "อุณหภูมิควบคุมสิ้นสุด",
          placeholder: "อุณหภูมิควบคุมสิ้นสุด",
          inputType: "number",
          isOneRow: true
        },
        {
          showSearch: false,
          fieldName: "status",
          label: "สถานะ",
          inputType: "select",
          defaultValue: "Y",
          options: optionStatus
        }
      ]
    }}
  />
}))

export default JobType